import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from '@angular/synthrone-design/services';
import { MatDialog } from '@angular/material';
import { ErrorComponent, AlertComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'platforms-view',
  templateUrl: './platforms-view.component.html',
  styleUrls: ['./platforms-view.component.scss']
})

export class PlatformsViewComponent implements OnInit {

  @ViewChild('platformTable') platformTable;

  configColumns = {
      id: {
          label: 'ID',
          sortable: true,
          truncate: true
      },
      name: {
          label: 'Name',
          sortable: true,
          truncate: true
      },
      slug: {
          label: 'Slug',
          sortable: true,
          truncate: true
      },
      url: {
          label: 'URL',
          sortable: true,
          truncate: true
      },
      country: {
          label: 'Country',
          sortable: true,
          truncate: true
      },
      language: {
          label: 'Language',
          sortable: true,
          truncate: true
      },
      storage: {
        label: 'Storage',
        sortable: true,
        truncate: true
      },
      clients_quantity: {
          label: 'Clients Quantity',
          sortable: false,
          truncate: true
      },
  };

  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  timeout = null;
  sortBy = 'id';
  sortOrder = 'asc';
  tableFilter = {
    'search': ''
  }

  constructor(private router: Router, private route: ActivatedRoute, protected dialog: MatDialog, protected api: ApiService) {}

  ngOnInit() {
    this.tableFilter = {
        'search': (typeof this.queryParams['search'] === "undefined") ? this.tableFilter.search : this.queryParams['search']
    }
  }

  setParams = () => {
      this.queryParams['search'] = this.tableFilter.search;
  }

  refreshTable = () => {
      this.platformTable.getData()
  }

  breadcrumbsFN = () => {
    return Observable.of([
      {
        breadcrumb: 'ADMINER',
        url: '/'
      },
      {
        breadcrumb: 'Manage platforms',
        url: '/platforms'
      }
    ]);
  };

  add = () => {
      this.router.navigate(['/platforms/add']);
  };

  editRow = (key) => {
    this.router.navigate(['/platforms/edit', key]);
  };

  deletePlatformFN = (key) => {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        message: 'Are you sure that you want to delete this platform?'
      }
    }).afterClosed().subscribe(result => {
      if (result === 'proceed') {
        this.api.makeRequest('api_platform_delete', {
          slug: key
        },
        'publisher').subscribe(
          (result) => {
            if (this.router.url === '/platforms') {
              this.platformTable.getData();
            } else {
              this.router.navigate(['/platforms']);
            }
          },
          (error) => {
            const dialogRef = this.dialog.open(ErrorComponent, {
              data: {
                message: error
              }
            });
          }
        );
      }

    });
  };

  sdPlatforms = (limit, offset, sortBy, sortOrder): Observable<any> => {
    if (!sortBy) {
        sortBy = 'id';
        sortOrder = 'asc';
    }

    return this.api.makeRequest('api_platform_list', {
          seed: new Date().getTime(),
          offset: offset,
          limit: limit,
          sortBy: sortBy,
          sortOrder: sortOrder,
          filterValue: this.tableFilter.search
      }, 'publisher');
  };

  editTemplate = (key) => {
    this.router.navigate(['/platforms/template', key]);
  }

  searchProductFN = () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
          this.setParams();
          this.router.navigate(['/platforms/1/10/'], { relativeTo: this.route, queryParams: this.queryParams });
          this.refreshTable();
      }, 2000);
  }

}




// WEBPACK FOOTER //
// ./src/app/components/views/platforms-view/platforms-view.component.ts